import {
    type LessonProgress,
    type ProjectProgress,
    type ProgressStatus,
    type StreamProgress,
} from '../ContentProgress.types';

export const getStreamProgressStatus = (streamProgress?: StreamProgress): ProgressStatus => {
    if (!streamProgress?.startedAt) return 'notStarted';

    if (streamProgress.completedAt) return 'completed';

    return 'inProgress';
};

export const getLessonProgressStatus = (lessonProgress?: LessonProgress): ProgressStatus => {
    if (!lessonProgress?.startedAt) return 'notStarted';

    if (lessonProgress.completedAt) return 'completed';

    return 'inProgress';
};

// Note that 'completed' here means "the project has been done", which includes failed.
export const getProjectProgressStatus = (projectProgress?: ProjectProgress): ProgressStatus => {
    if (!projectProgress) return 'notStarted';

    if (projectProgress.waived) return 'completed';
    if (typeof projectProgress.score === 'number') return 'completed';
    if (projectProgress.allowResubmission) return 'notStarted';

    return 'inProgress';
};
